var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "topbar" }, [
      _c("i", { on: { click: _vm.goHome } }),
      _vm._v(" "),
      _c("div", { staticClass: "mainBox1" }, [
        _c(
          "div",
          {
            staticClass: "changeLangBtn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.moreLang()
              }
            }
          },
          [
            _vm._v(
              "\r\n           " + _vm._s(_vm.$t("language")) + "\r\n          "
            ),
            _c("em", { staticClass: "iconfont icon-een" }),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.changeLangBox,
                    expression: "changeLangBox"
                  }
                ],
                staticClass: "chooseLangUl"
              },
              _vm._l(_vm.langList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "chooseLangUlli",
                    on: {
                      click: function($event) {
                        _vm.setLanguage(item.id)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              })
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "changeLangBtn1",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.goLogin()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("homepage_button1")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "banner" }, [
      _c("div", { staticClass: "forget" }, [
        _c("div", { staticClass: "forgetPsd" }, [
          _vm._v(_vm._s(_vm.$t("signup_email1")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.$t("signup_email2")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content content33" }, [
          _vm._v(_vm._s(_vm.$t("signup_email4")))
        ]),
        _vm._v(" "),
        _c("button", { staticClass: "signIn", on: { click: _vm.sucess } }, [
          _vm._v(_vm._s(_vm.$t("signup_email3")))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63066b66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63066b66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/activateRes.vue
// module id = null
// module chunks = 